import { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setModal } from "../actions";

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = this.props.modalPopup;
  }
  componentWillReceiveProps(nextProps) {
    this.setState(nextProps.modalPopup);
  }

  render() {
    if (this.state.open) {
      return (
        <>
          <div className="modal-backdrop fade show"></div>
          <div
            className="modal fade show"
            tabIndex="-1"
            style={{ display: "block" }}
            role="dialog"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    {this.state.title}
                  </h5>
                  <button
                    type="button"
                    className="close"
                    onClick={() => this.props.setModal()}
                  >
                    <span>&times;</span>
                  </button>
                </div>
                <div className="modal-body">{this.state.content}</div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => this.props.setModal()}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => this.state.onSave?.()}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    } else {
      return null;
    }
  }
}

function mapStateToProps(state) {
  return {
    modalPopup: state.modalPopup,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setModal: setModal,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
